import request from '@/utils/request'

// #region --------------------------内部资料管理------------------------------
/**
 * 保存内部资料管理分类
 * @param {object} parameter
 */
export function addDataManagementTypeInternalApi (parameter) {
  return request({
    url: '/sys/DataManagementTypeInternal/',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改内部资料管理分类
 * @param parameter
 */
export function updateDataManagementTypeInternalApi (parameter) {
  return request({
    url: `/sys/DataManagementTypeInternal/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 查询内部资料管理分类列表
 * @param {object} parameter
 */
export function getDataManagementTypeInternalApi (parameter) {
  return request({
    url: '/sys/DataManagementTypeInternal/listTree',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询内部资料管理分类详情
 * @param {String} id
 */
export function getDataManagementTypeInternalInfoApi (id) {
  return request({
    url: `/sys/DataManagementTypeInternal/${id}`,
    method: 'get'
  })
}

/**
 * 根据id删除内部资料管理分类
 * @param {String} id
 */
export function deleteDataManagementTypeInternalApi (id) {
  return request({
    url: `/sys/DataManagementTypeInternal/${id}`,
    method: 'delete'
  })
}

/**
 * 保存内部资料管理表
 * @param {object} parameter
 */
export function addDataManagementInternalApi (parameter) {
  return request({
    url: '/sys/DataManagementInternal/',
    method: 'post',
    data: parameter
  })
}

/**
 * 批量保存内部资料管理表
 * @param {object} parameter
 */
export function batchUploadDataManagementInternalApi (parameter) {
  return request({
    url: '/sys/DataManagementInternal/batchUpload',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改内部资料管理表
 * @param parameter
 */
export function updateDataManagementInternalApi (parameter) {
  return request({
    url: `/sys/DataManagementInternal/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 容量进度条
 * @param {object} parameter
 */
export function getCapacityProgressBarApi (parameter) {
  return request({
    url: '/sys/DataManagementInternal/capacityProgressBar',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询内部资料管理表列表
 * @param {object} parameter
 */
export function getDataManagementInternalListApi (parameter) {
  return request({
    url: '/sys/DataManagementInternal/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询内部资料管理表详情
 * @param {String} id
 */
export function getDataManagementInternalInfoApi (id) {
  return request({
    url: `/sys/DataManagementInternal/${id}`,
    method: 'get'
  })
}

/**
 * 根据id删除内部资料管理表
 * @param {String} id
 */
export function deleteDataManagementInternalApi (id) {
  return request({
    url: `/sys/DataManagementInternal/${id}`,
    method: 'delete'
  })
}
// #endregion
